<template>
	<div class="form-links">
		<div class="form-portfolio-link">
			<p class="form--input">
				<label for="portfolio_link">Portfolio link (optional)</label>
			</p>

			<div class="divider-md"></div>
			<input
				id="portfolio_link"
				name="portfolio_link"
				v-model="portfolio_link"
				@change="updatePortfolio"
				@input="$v.portfolio_link.$touch()"
				type="text"
				class="input-text__form"
				placeholder="https://my-portfolio.com"
				v-bind:class="{
					error: $v.portfolio_link.$error,
					valid:
						$v.portfolio_link.$dirty && !$v.portfolio_link.$invalid
				}"
			/>
			<span
				class="form-group__message"
				v-if="!$v.portfolio_link.url && $v.portfolio_link.$error"
				>Please, provide valid url address or leave empty</span
			>
		</div>
		<div class="form-additional-link">
			<p class="form--input">
				<label for="additional_link">Additional link (optional)</label>
			</p>

			<div class="divider-md"></div>
			<input
				id="additional_link"
				name="additional_link"
				v-model="additional_link"
				@change="updateAdditional"
				@input="$v.additional_link.$touch()"
				type="text"
				class="input-text__form"
				placeholder="https://my-other-portfolio.com"
				v-bind:class="{
					error: $v.additional_link.$error,
					valid:
						$v.additional_link.$dirty &&
						!$v.additional_link.$invalid
				}"
			/>
			<span
				class="form-group__message"
				v-if="!$v.additional_link.url && $v.additional_link.$error"
				>Please, provide valid url address or leave empty</span
			>
		</div>
		<span class="attachment-text"
			>Link additional materials (Portfolio, Website, YouTube, etc.).</span
		>
	</div>
</template>

<script>
import EventBus from "../../EventBus";
import { url } from "vuelidate/lib/validators";

export default {
	data() {
		return { portfolio_link: null, additional_link: null };
	},
	validations() {
		let rules = {
			portfolio_link: {
				url
			},
			additional_link: {
				url
			}
		};
		return rules;
	},
	methods: {
		updatePortfolio() {
			EventBus.$emit("portfolio_link", this.portfolio_link);
		},
		updateAdditional() {
			EventBus.$emit("additional_link", this.additional_link);
		}
	}
};
</script>

<style lang="scss" scoped type="text/scss">
@import "../../assets/scss/globals";

.form-links {
	width: 100%;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;

	.form-portfolio-link {
		width: 49%;
	}
	.form-additional-link {
		width: 49%;
		margin-left: auto;
	}
	@media (max-width: $compact) {
		flex-direction: column;
		.form-portfolio-link {
			width: 100%;
		}
		.form-additional-link {
			width: 100%;
		}
	}
}
.form--input {
	label {
		font-family: "Inter UI", sans-serif;
		font-size: 22px;
		line-height: 28px;
		letter-spacing: 0.02px;
		font-weight: 400;
	}
}

.attachment-text {
	font-family: "Inter UI", sans-serif;
	font-weight: 400;
	line-height: 24px;
	font-size: 14px;
	color: #808080;
	margin-top: 20px;
}

.input-text__form {
	color: #1a1a1a;
}

.form-group__message {
	color: #c32121;
	font-size: 12px;
}

.error {
	border-color: red;
	background: #fdd;
}

.error:focus {
	outline-color: #f99;
}

.valid {
	border-color: #70c165;
}

.valid:focus {
	outline-color: #70c165;
}
</style>



// WEBPACK FOOTER //
// src/components/applicationPageComponents/LinksPicker.vue